import React from 'react'
import { motion } from 'framer-motion'
import attioLogo from '../../assets/attio.png'
import clickupLogo from '../../assets/clickup.png'
import zohoLogo from '../../assets/zoho.png'
import lookerstudio from '../../assets/looker-studio-logo-png_seeklogo-617989.png'
const integrations = [
  { name: 'Attio', color: '#111111', logo: attioLogo, type: 'image' },
  { name: 'ClickUp', color: '#7B68EE', logo: clickupLogo, type: 'image' },
  { name: 'Zoho Books', color: '#0066CC', logo: zohoLogo, type: 'image' },
  {
    name: 'Looker Studio',
    color: '#4285F4',
    logo: lookerstudio,
    type: 'image',
  },
]

const Integrations: React.FC = () => {
  return (
    <section className='py-24 bg-[#0a0a0a] border-t border-[#1f1f1f] overflow-hidden relative'>
      <div className='absolute inset-0 z-0'>
        <div className='absolute bottom-[-10%] right-[-10%] w-[30vw] h-[30vw] rounded-full bg-primary/10 mix-blend-screen filter blur-[80px] opacity-40'></div>
        <div className='absolute top-[-10%] left-[-10%] w-[30vw] h-[30vw] rounded-full bg-indigo-900/20 mix-blend-screen filter blur-[80px] opacity-40'></div>
      </div>

      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10'>
        <div className='flex flex-col lg:flex-row items-center justify-between gap-12'>
          <div className='lg:w-1/2 max-w-xl text-center lg:text-left'>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className='inline-flex items-center px-3 py-1 rounded-full border border-[#262626] bg-[#1a1a1a] text-xs font-semibold text-slate-400 tracking-wide uppercase mb-4'
            >
              Integrations
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className='text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight leading-tight mb-6'
            >
              Works with your <br className='hidden md:block' />
              <span className='text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-500'>
                favorite tools
              </span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className='text-lg text-slate-400 mb-8 leading-relaxed'
            >
              Connect instantly with the tools your team already uses. Eliminate
              silos, automate tedious tasks, and keep data perfectly
              synchronized across your entire stack.
            </motion.p>
            <motion.button
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className='flex items-center gap-2 text-primary font-semibold hover:text-primary/80 transition-colors group mx-auto lg:mx-0'
            >
              View all 100+ integrations
              <svg
                className='w-4 h-4 transform group-hover:translate-x-1 transition-transform'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M14 5l7 7m0 0l-7 7m7-7H3'
                />
              </svg>
            </motion.button>
          </div>

          <div className='lg:w-1/2 w-full'>
            <div className='grid grid-cols-2 sm:grid-cols-3 gap-4'>
              {integrations.map((app, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9, y: 20 }}
                  whileInView={{ opacity: 1, scale: 1, y: 0 }}
                  viewport={{ once: true, margin: '-50px' }}
                  animate={{
                    y: [0, -10, 0],
                  }}
                  transition={{
                    duration: 0.5,
                    delay: index * 0.1,
                    type: 'spring',
                    stiffness: 100,
                    y: {
                      duration: 4,
                      repeat: Infinity,
                      ease: 'easeInOut',
                      delay: index * 0.5,
                    },
                  }}
                  whileHover={{ scale: 1.05, filter: 'grayscale(0%)' }}
                  className='bg-[#1a1a1a] rounded-2xl p-6 flex flex-col items-center justify-center gap-3 aspect-square border border-[#262626] shadow-sm cursor-pointer grayscale opacity-70 hover:opacity-100 hover:shadow-2xl hover:border-primary/30 transition-all duration-500 z-10'
                >
                  {app.type === 'image' && app.logo && (
                    <img
                      src={app.logo}
                      alt={app.name}
                      className='w-12 object-contain'
                    />
                  )}

                  <span className='text-sm font-semibold text-slate-300 text-center'>
                    {app.name}
                  </span>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Integrations
